import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    title: {
        fontSize: '1.25rem',
        fontWeight: 400,
        marginTop: '1rem',
        marginBottom: '0.5rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: '0',
        },
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '14px',
    },
    clipboard: {
        backgroundColor: '#f3f3f3',
        borderRadius: '15px',
        padding: '10px 15px',
        overflowWrap: 'break-word',
        fontSize: '16px',
        fontWeight: 400,
        cursor: 'pointer',
    },
    copyLinkText: {
        fontSize: 16,
        fontWeight: 400,
        marginTop: '25px',
        marginBottom: '10px',
    },
}));
